import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/views/index'
import SearchList from '@/views/searchList'
import InformationDynamics from '@/views/InformationDynamics'
import InformationDynamicsDetail from '@/views/InformationDynamicsDetail'
import ProductCenter from '@/views/productCenter'
import CompanyIntro from '@/views/aboutUs/companyIntro'
import MessageBoard from '@/views/aboutUs/messageBoard'


Vue.use(Router)
export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      meta: {
        title: '首页',
        keepAlive: true,
      }
    },
    {
      path: "/InformationDynamics",
      name: "InformationDynamics",
      component: InformationDynamics,
      meta: {
        title: '资讯列表',
        keepAlive: true,
      }
    },
    {
      path: "/InformationDynamicsDetail",
      name: "InformationDynamicsDetail",
      component: InformationDynamicsDetail,
      meta: {
        title: '资讯详情',
        keepAlive: true,
      }
    },
    {
      path: "/productCenter",
      name: "productCenter",
      component: ProductCenter,
      meta: {
        title: '产品中心列表',
        keepAlive: true,
      }
    },
    {
      path: "/companyIntro",
      name: "companyIntro",
      component: CompanyIntro,
      meta: {
        title: '公司介绍',
        keepAlive: true,
      }
    },

    {
      path: "/messageBoard",
      name: "messageBoard",
      component: MessageBoard,
      meta: {
        title: '留言板',
        keepAlive: true,
      }
    },
    {
      path: "/searchList",
      name: "searchList",
      component: SearchList,
      meta: {
        title: '搜索列表',
        keepAlive: true,
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js